import { render } from "./HeaderNotificationsComponent.vue?vue&type=template&id=cd0d4f10&scoped=true"
import script from "./HeaderNotificationsComponent.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsComponent.vue?vue&type=script&lang=js"

import "./HeaderNotificationsComponent.vue?vue&type=style&index=0&id=cd0d4f10&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0d4f10"]])

export default __exports__